<template>
    <div><h1 style="font-size: 24px; color: black;">欢迎登录</h1></div>
</template>

<script>
    export default {
        name: "Welcome"
    }
</script>

<style scoped>

</style>